"use client";
import TrashIcon from "@/app/assets/images/svg/trash.svg";
import IconOnlyButton from "@/components/UI/Button/IconOnlyButton/IconOnlyButton";
import {
	getCartDatalayerDetails,
	useDataLayerContext,
} from "@/datalayer/DataLayerContextProvider";
import { CartPhysicalItem, ProductData } from "@/lib/5874/types";
import { useCartContext } from "@/providers/CartContextProvider";
import { Form } from "@radix-ui/react-form";
import { FormProvider, useForm } from "react-hook-form";
import { handleDeleteCartLineItem } from "./_actions/removeFromCart";

interface Props {
	lineItem: CartPhysicalItem;
	product: ProductData | undefined;
	className?: string;
}

export const RemoveItemForm = ({ lineItem, product, className }: Props) => {
	const { setCart, setIsModifyingCart, cart } = useCartContext();
	const { removeFromCart } = useDataLayerContext();
	const { handleSubmit, register, ...methods } = useForm();

	if (!lineItem) {
		return null;
	}

	// Datalayer
	const cartDetails = getCartDatalayerDetails(cart);
	const datalayerProduct = {
		product,
		quantity: lineItem.quantity,
		variantId: lineItem.product_id,
	};

	const productFormSubmit = async () => {
		setIsModifyingCart(true);
		const res = await handleDeleteCartLineItem(lineItem);
		/* TODO - This works to remove an iterm from the UI. All DELETE requests return an error
		because we try to return the body as the result.
		 */
		if (res.status === "success") {
			setCart(res.data);
		} else {
			setCart(undefined);
		}
		removeFromCart({
			products: [datalayerProduct],
			itemListId: "cart",
			itemListName: "Cart",
			cart: cartDetails,
		});
		setIsModifyingCart(false);
	};

	return (
		<FormProvider handleSubmit={handleSubmit} register={register} {...methods}>
			<Form onSubmit={handleSubmit(productFormSubmit)} className={className}>
				<IconOnlyButton variant='tertiary' icon={<TrashIcon />} type='submit' />
			</Form>
		</FormProvider>
	);
};
